angular.module('dpw.components')

    .factory('appProfileUtils', ['$window', '$location', '$rootScope', '$timeout', 'api', 'Upload', 'popupUtil', 'popup',
        '$q', 'dpwRoutes', 'applicationService', 'mixpanelService', 'dpwStorage',
        function ($window, $location, $rootScope, $timeout, api, Upload, popupUtil, popup,
                  $q, dpwRoutes, applicationService, mixpanelService, dpwStorage) {
            var profileStatus = {
                'Initialized': 'Initialized',
                'InReview': 'Pending',
                'Declined': 'Declined',
                'Published': 'Published',
                'UnPublished': 'Approved'
            };

            var profileTypes = {
                'Origin': {
                    key: 'origin',
                    api: '/api/app-gallery'
                },
                'Revision': {
                    key: 'revision',
                    api: '/api/app-profile-revision'
                }
            };

            return {
                profileStatus: profileStatus,
                profileTypes: profileTypes,

                /**
                 * Common Utils
                 */
                convertOriginRevision: function (data) {
                    var records = data.records || [];
                    return records.map(function (e) {
                        return {
                            id: _.get(e, 'appProfileAndRevisionViewId.appProfileId'),
                            applicationId: e.applicationId,
                            organizationId: e.organizationId,
                            appGalleryName: e.name,
                            urlPathName: e.vanityUrl,
                            brand: e.brandId,
                            publisher: e.publisher,
                            status: e.status,
                            createdTime: e.createdTime,
                            latestRequestTime: e.latestRequestTime,
                            modifiedTime: e.modifiedTime,
                            releaseTime: e.releaseTime,
                            type: _.get(e, 'appProfileAndRevisionViewId.type')
                        };
                    });
                },
                convertToTemplateItem: function (data) {
                    var records = data.records || [];
                    return records.map(function (record) {
                        var profile = record.appProfile;
                        return {
                            applicationId: profile.appId,
                            organizationId: profile.orgId,
                            appGalleryName: record.name,
                            publisher: profile.publisher,
                            h1Tag: profile.h1Tag,
                            urlPathName: profile.urlPathName,
                            requestTime: record.requestTime
                        };
                    });
                },
                isInitialized: function (status) {
                    return _.isEqual(status, profileStatus.Initialized) || _.isUndefined(status);
                },

                isInReview: function (status) {
                    return _.isEqual(status, profileStatus.InReview);
                },

                isDeclined: function (status) {
                    return _.isEqual(status, profileStatus.Declined);
                },

                isPublished: function (status) {
                    return _.isEqual(status, profileStatus.Published);
                },

                isUnPublished: function (status) {
                    return _.isEqual(status, profileStatus.UnPublished);
                },

                isApproved: function (status) {
                    return _.includes([profileStatus.Published, profileStatus.UnPublished], status);
                },

                isAppPublishEnabled: function (application) {
                    var appScope = _.get(application, 'scope');
                    return _.include(['Public', 'Internal'], appScope);
                },

                profileErrorHandler: function (data, extraHandlerConfig, defaultErrorHandler) {
                    var errorHandlerConfig = {};

                    var handleWithMessage = [
                        'PROFILE_ALREADY_EXIST',
                        'IMAGES_COUNT_EXCEED',
                        'APP_IS_NOT_PUBLIC',
                        'CANNOT_BE_EDITED',
                        'INVALID_BRAND',
                        'NO_SUCH_PROFILE',
                        'INVALID_APP_STATUS_SCOPE',
                        'IS_NOT_A_IMAGE',
                        'MALICE_IMAGE_URL',
                        'FORBIDDEN_FOR_CURRENT_STATUS'
                    ];

                    _.forEach(handleWithMessage, function (errorCode) {
                        errorHandlerConfig[errorCode] = buildPromptFn({
                            errorCode: errorCode
                        });
                    });

                    var refreshAfterPrompt = ['STATUS_CHANGED'];

                    _.forEach(refreshAfterPrompt, function (errorCode) {
                        errorHandlerConfig[errorCode] = buildPromptFn({
                            errorCode: errorCode,
                            refreshAfterPrompt: true
                        });
                    });

                    _.assign(errorHandlerConfig, extraHandlerConfig);

                    var currentErrorCode = _.get(data, 'status.message');
                    var currentHandler = errorHandlerConfig[currentErrorCode];

                    currentHandler ? currentHandler() : (_.isFunction(defaultErrorHandler) && defaultErrorHandler());

                    function buildPromptFn(config) {
                        var options = _.cloneDeep(config) || {};
                        options.message = RCDPW.Lang.DynamicAppGallery[options.errorCode];

                        return function () {
                            popupErrorMessage(options);
                        };
                    }
                },

                /**
                 * `dpw-app-profile-info` utils
                 */

                appNotGraduated: function (options) {
                    var devSiteButtons = [{
                        label: 'Cancel',
                        style: 'button-with-border',
                        action: 'close'
                    }, {
                        label: 'Status & Review',
                        style: 'button-orange',
                        action: function () {
                            var statusAndReviewPath = '/status-and-review/' + _.get(options.application, 'id');
                            $location.url(statusAndReviewPath);
                        }
                    }];

                    var adminSiteButtons = [{
                        label: 'OK',
                        style: 'button-with-border',
                        action: 'close'
                    }];

                    options = options || {};
                    popupUtil.confirm({
                        title: 'Sorry!',
                        content: "You can't publish this app now as it is not graduated for production yet. " +
                            "Please submit request again once your app is Active on production.",
                        buttons: RCDPW.isAdminSite ? adminSiteButtons : devSiteButtons
                    });
                },

                hasLinkedApp: function (appProfile) {
                    var linkedAppId = _.get(appProfile, 'applicationId');
                    return _.size(linkedAppId) > 0;
                },

                isLinkedAppNormal: function (appProfile) {
                    var linkedAppName = _.get(appProfile, 'applicationName');
                    return _.size(linkedAppName) > 0;
                },

                getAppProfileDetailUrl: function (appId) {
                    return 'manage-app-gallery/profile/' + appId;
                },

                onEditProfile: function () {
                    dpwStorage.setItem('pageBeforeEditProfile', location.href);
                },

                getColorClassByProfileStatus: function (status) {
                    var self = this;
                    var color = '';
                    var classPrefix = 'app-profile-info-status-text-';
                    var statusColorConfig = [{
                        checker: self.isInitialized,
                        color: 'orange'
                    }, {
                        checker: self.isInReview,
                        color: 'orange'
                    }, {
                        checker: self.isDeclined,
                        color: 'red'
                    }, {
                        checker: self.isApproved,
                        color: 'green'
                    }];

                    _.forEach(statusColorConfig, function (config) {
                        config.checker(status) && (color = config.color);
                    });

                    return classPrefix + color;
                },

                storeDraftProfile: function (profileData) {
                    this.draftAppProfile = profileData;
                },

                getDraftProfile: function () {
                    return this.draftAppProfile;
                },

                clearDraftProfile: function () {
                    this.draftAppProfile = null;
                },

                previewOnWebsite: function ($scope) {
                    var self = this;

                    $scope.$broadcast('appProfileForm:getProfileData', function callback(profileData) {
                        profileData.profileUrl = $location.path();
                        self.storeDraftProfile(profileData);
                        $location.path($location.path() + '/preview');
                    });
                },

                getPreviewUrl: function (appProfileId) {
                    return $q(function (resolve) {
                        api.call(api.myAccount.applications.publish.getPreviewUrl({appProfileId: appProfileId}), function (data) {
                            var previewUrl = _.get(data, 'previewUrl');
                            resolve(previewUrl);
                        });
                    });
                },

                getRevisionPreviewUrl: function (appProfileId) {
                    return $q(function (resolve) {
                        api.call(api.appProfileRevision.previewUrl(appProfileId), function (data) {
                            resolve(data.previewUrl);
                        });
                    });
                },

                /**
                 * `dpw-app-profile-form` utils
                 */

                fetchProfile: function (appId, brandId) {
                    return $q(function (resolve, reject) {
                        api.call(api.myAccount.applications.publish.get({
                            applicationId: appId,
                            brand: brandId
                        }), function (data) {
                            resolve(data.appProfile);
                        }, function (data, defaultErrorHandler) {
                            reject({
                                data: data,
                                defaultErrorHandler: defaultErrorHandler
                            });
                        });
                    });
                },

                uploadImages: function (fileObjs, orgId) {
                    var newImages = _.filter(fileObjs, function (fileObj) {
                        return !_.isEmpty(fileObj.file);
                    });
                    return api.call(api.appGallery.initImageDir({
                        organizationId: orgId
                    })).then(function () {
                        return uploadImages();
                    });

                    function uploadImages() {
                        var uploadPromises = [];
                        _.forEach(newImages, function (image) {
                            var httpPromise = Upload.upload({
                                url: '/api/app-gallery/upload-image',
                                arrayKey: '',
                                data: {
                                    organizationId: orgId,
                                    images: [image]
                                }
                            });

                            uploadPromises.push(api.call(httpPromise, function (data) {
                                image.url = _.first(data.imageUrls);
                                image.file = '';
                            }, function (data, defaultErrorHandler) {
                                if (_.get(data, 'status.message') === "IS_NOT_A_IMAGE") {
                                    popupUtil.ok({
                                        content: RCDPW.Lang.DynamicAppGallery['IS_NOT_A_IMAGE']
                                    });
                                } else {
                                    defaultErrorHandler();
                                }
                            }));
                        });
                        return $q.all(uploadPromises);
                    }
                },

                trackAppProfileSubmissionEvent: function (options) {
                    options = options || {};

                    var orgName = options.orgName;
                    var orgType = options.orgType;
                    var appId = options.appId;
                    var appProfileName = options.appProfileName;
                    var requestBy = options.requestBy;
                    var appName = options.appName;
                    var appType = options.appType;
                    var platformType = options.platformType;
                    var permissions = options.permissions;
                    var categories = options.categories;
                    var shortDesc = options.shortDesc;
                    var brandName = options.brandName;
                    var isRevision = options.isRevision;
                    var shouldRestoreIdentity = options.shouldRestoreIdentity;

                    return applicationService.trackAsAppCreator({
                        appId: appId,
                        shouldRestoreIdentity: shouldRestoreIdentity,
                        trackingExecutor: function () {
                            var eventName = mixpanelService.eventNames.APP_PROFILE_SUBMISSION;
                            return mixpanelService.performTracking(eventName, {
                                'App Name': appName,
                                'App Type': appType,
                                'Platform Type': platformType,
                                'Permissions': permissions,
                                'Org Type': orgType,
                                'Profile Name': appProfileName,
                                'Categories': categories,
                                'Short Description': shortDesc,
                                'Carrier Partner': brandName,
                                'Request Date': (new Date()).toISOString(),
                                'Is Revision': isRevision
                            });
                        }
                    });
                },

                trackAppProfilesSubmissionEvent: function (options) {
                    options = options || {};

                    return applicationService.trackAsAppCreator({
                        appId: options.appId,
                        shouldRestoreIdentity: options.shouldRestoreIdentity,
                        trackingExecutor: function () {
                            var eventName = mixpanelService.eventNames.APP_PROFILE_SUBMISSION;
                            return $q.all(options.brandNames.map(function (brandName) {
                                return mixpanelService.performTracking(eventName, {
                                    'App Name': options.appName,
                                    'App Type': options.appType,
                                    'Platform Type': options.platformType,
                                    'Permissions': options.permissions,
                                    'Org Type': options.orgType,
                                    'Profile Name': options.appProfileName,
                                    'Categories': options.categories,
                                    'Short Description': options.shortDesc,
                                    'Carrier Partner': brandName,
                                    'Request Date': (new Date()).toISOString(),
                                    'Is Revision': options.isRevision
                                });
                            }));
                        }
                    });
                },

                trackAppProfileApprovalEvent: function (options) {
                    options = options || {};

                    var orgName = options.orgName;
                    var orgType = options.orgType;
                    var appId = options.appId;
                    var appProfileName = options.appProfileName;
                    var requestDate = options.requestDate;
                    var requestBy = options.requestBy;
                    var approvedBy = options.approvedBy;
                    var appName = options.appName;
                    var appType = options.appType;
                    var platformType = options.platformType;
                    var categories = options.categories;
                    var permissions = options.permissions;
                    var publishDate = options.publishDate;
                    var isFuture = options.isFuture;
                    var shortDesc = options.shortDesc;
                    var brandName = options.brandName;
                    var shouldRestoreIdentity = options.shouldRestoreIdentity;

                    return applicationService.trackAsAppCreator({
                        appId: appId,
                        shouldRestoreIdentity: shouldRestoreIdentity,
                        trackingExecutor: function () {
                            var eventName = mixpanelService.eventNames.APP_PROFILE_APPROVAL;
                            return mixpanelService.performTracking(eventName, {
                                'App Name': appName,
                                'App Type': appType,
                                'Platform Type': platformType,
                                'Org Type': orgType,
                                'Profile Name': appProfileName,
                                'Categories': categories,
                                'Permissions': permissions,
                                'Publish Date': publishDate,
                                'Is future': isFuture,
                                'Short Description': shortDesc,
                                'Carrier Partner': brandName,
                                'Request Date': requestDate,
                                'Approved Date': (new Date()).toISOString(),
                            });
                        }
                    });
                },

                trackAppProfileRejectEvent: function (options) {
                    options = options || {};

                    var orgName = options.orgName;
                    var orgType = options.orgType;
                    var appId = options.appId;
                    var appProfileName = options.appProfileName;
                    var requestDate = options.requestDate;
                    var requestBy = options.requestBy;
                    var rejectBy = options.rejectBy;
                    var rejectReason = options.rejectReason;
                    var appName = options.appName;
                    var appType = options.appType;
                    var platformType = options.platformType;
                    var categories = options.categories;
                    var permissions = options.permissions;
                    var shortDesc = options.shortDesc;
                    var brandName = options.brandName;
                    var shouldRestoreIdentity = options.shouldRestoreIdentity;

                    return applicationService.trackAsAppCreator({
                        appId: appId,
                        shouldRestoreIdentity: shouldRestoreIdentity,
                        trackingExecutor: function () {
                            var eventName = mixpanelService.eventNames.APP_PROFILE_REJECT;
                            return mixpanelService.performTracking(eventName, {
                                'App Name': appName,
                                'App Type': appType,
                                'Platform Type': platformType,
                                'Permissions': permissions,
                                'Org Type': orgType,
                                'Profile Name': appProfileName,
                                'Categories': categories,
                                'Short Description': shortDesc,
                                'Carrier Partner': brandName,
                                'Request Date': requestDate,
                                'Reject Date': (new Date()).toISOString(),
                                'Reason': rejectReason
                            });
                        }
                    });
                },

                updateProfile: function (profile, profileType, onSuccess, onError) {

                    // deal with angular js trick
                    _.forEach(profile, function (value, name) {
                        if (_.isUndefined(value)) {
                            profile[name] = '';
                        }
                    });

                    var httpPromise = Upload.upload({
                        url: profileType.api,
                        arrayKey: '',
                        data: profile
                    });

                    api.call(httpPromise, onSuccess, onError);
                },

                setProfileFormDirty: function (isDirty) {
                    isDirty = isDirty !== false;
                    RCDPW.isAppProfileFormDirty = isDirty;
                },

                isProfileFormDirty: function () {
                    return RCDPW.isAppProfileFormDirty;
                },

                isUnableToEdit: function (status) {
                    if (RCDPW.isAdminSite) {
                        return false;
                    }
                    return _.includes([profileStatus.InReview, profileStatus.UnPublished, profileStatus.Published], status);
                },

                textFormatUtils: (function () {
                    var formatConfig = {
                        plainText: {
                            id: '[pt]',
                            idPattern: /^\[pt\]/,
                            name: 'Plain text'
                        },
                        markdown: {
                            id: '[md]',
                            idPattern: /^\[md\]/,
                            name: 'Markdown',
                            isDefault: true
                        }
                    };

                    return {
                        formatConfig: formatConfig,
                        initFormatSettings: initFormatSettings,
                        prependFormatId: prependFormatId,
                        addressFormatId: addressFormatId,
                        detectFormat: detectFormat
                    };

                    function initFormatSettings(textFormatSettings, keyNames) {
                        _.forEach(keyNames, function (keyName) {
                            textFormatSettings[keyName] = getDefaultFormatId();
                        });
                    }

                    function prependFormatId(appProfile, keyNames, textFormatSettings) {
                        _.forEach(keyNames, function (keyName) {
                            var formatId = textFormatSettings[keyName];
                            appProfile[keyName] = [formatId, appProfile[keyName] || ''].join('');
                        });
                    }

                    function addressFormatId(appProfile, keyNames, textFormatSettings) {
                        _.forEach(keyNames, function (keyName) {
                            var detectedInfo = detectFormat(appProfile[keyName]);

                            // Force to use markdown for now
                            textFormatSettings[keyName] = formatConfig.markdown.id;

                            appProfile[keyName] = detectedInfo.text || '';
                        });
                    }

                    function detectFormat(text) {
                        var detectedInfo = {
                            format: getDefaultFormatId(),
                            text: text
                        };

                        _.forEach(formatConfig, function (config) {
                            var formatId = config.id;
                            var idPattern = config.idPattern;
                            if (_.startsWith(text, formatId)) {
                                detectedInfo.format = formatId;
                                detectedInfo.text = text.replace(idPattern, '');
                            }
                        });

                        return detectedInfo;
                    }

                    function getDefaultFormatId() {
                        var defaultFormatKey = _.findKey(formatConfig, {isDefault: true});
                        return formatConfig[defaultFormatKey].id;
                    }
                })(),

                /**
                 * `dpw-app-profile-history` utils
                 */

                fetchDevelopers: function (options) {
                    var self = this;
                    options = options || {};

                    if (RCDPW.isAdminSite) {
                        api.call(api.admin.developers.list({organizationId: options.organizationId}, {perPage: 100}))
                            .then(onSuccess, options.onError);
                    } else {
                        api.call(api.myAccount.developers.list({perPage: 100}))
                            .then(onSuccess, options.onError);
                    }

                    function onSuccess(data) {
                        self.developers = data.developers;
                        _.isFunction(options.onSuccess) && options.onSuccess(data);
                    }
                },

                getDeveloperList: function () {
                    return this.developers;
                },

                getLatestRequestBy: function (appId) {
                    return $q(function (resolve, reject) {
                        if (!RCDPW.isAdminSite) {
                            reject();
                            return;
                        }

                        api.call(api.admin.profileTemplate.getLatestRequestBy({
                            appId: appId
                        }), function (data) {
                            var developer = data.developer;
                            resolve({
                                isAdmin: developer === void 0,
                                developer: developer
                            });
                        }, function () {
                            reject();
                        });
                    });
                }
            };

            function popupErrorMessage(config) {
                config = config || {};
                var options = {content: config.message};

                config.refreshAfterPrompt && _.assign(options, {
                    btnName: 'Refresh the page',
                    callback: function () {
                        $window.location.reload();
                    }
                });

                popupUtil.ok(options);
            }
        }
    ])

    .directive('dpwAppProfileActionPopup', [function () {
        return {
            restrict: 'A',
            scope: true,
            templateUrl: 'dpw-app-profile-action-popup.html',
            controllerAs: 'ctrl',
            controller: ['$scope', function ($scope) {
                var self = this;
                _.assign(self, $scope.config);
            }]
        };
    }])

    .filter('appProfileStatusDisplayName', [function () {
        var commonTransformationRules = {
            'Initialized': 'Draft',
            'Pending': 'In Review',
            'Declined': 'Declined'
        };

        var publishStatusCombinedRules = _.assign({}, commonTransformationRules, {
            'Approved': 'Approved',
            'Published': 'Approved'
        });

        var publishStatusDifferentiatedRules = _.assign({}, commonTransformationRules, {
            'Approved': 'Approved',
            'Published': 'Published'
        });

        return function (status, combinePublishStatus) {
            status = status || 'Initialized';
            combinePublishStatus = combinePublishStatus !== false;

            var statusDisplayName = '';

            statusDisplayName = combinePublishStatus ?
                publishStatusCombinedRules[status] :
                publishStatusDifferentiatedRules[status];

            return statusDisplayName || status;
        };
    }])

;
